export const updateUiState = (uiConfig, setUiState) =>
  setUiState(prevState => ({ ...prevState, ...uiConfig }));
